import React from 'react';
import { Skeleton } from '@mui/material';

import MessageCard from './MessageCard';
import CommonLoader from '../../../components/common-loader/CommonLoader';
import EmptyMessagesList from './EmptyMessagesList';
import { useSelector } from 'react-redux';

import scss from './MessagesList.module.scss';

function MessagesList({ isLoading, content, searchStr, selectedMessage, onMessageSelect }) {
  const isProjectLoading = useSelector((state) => state.resonance.isProjectLoading);

  return isProjectLoading ? (
    <Skeleton animation='wave' variant='rounded' height={360} />
  ) : (
    <div className={scss.listWrapper}>
      {content.length ? (
        content.map((message) => (
          <MessageCard
            key={message.id}
            message={message}
            isSelected={message.id === selectedMessage?.id}
            searchStr={searchStr}
            onMessageSelect={onMessageSelect}
          />
        ))
      ) : (
        <EmptyMessagesList />
      )}
      <CommonLoader isLoading={isLoading} />
    </div>
  );
}

export default MessagesList;
